import { HiChevronDown } from 'react-icons/hi'

interface IBriefFontSelectionToggle {
  dropdownIsOpen: boolean
  onToggle: () => void
}

export function BriefFontSelectionToggle({
  dropdownIsOpen,
  onToggle,
}: IBriefFontSelectionToggle) {
  return (
    <div
      className="w-full px-6 py-4 flex items-center justify-between h-[56px]"
      onClick={onToggle}
    >
      <p className="text-[14px] leading-none mb-2 select-none text-core-grey-80">
        Add Font
      </p>

      <HiChevronDown
        className={`text-4xl transition-all ${
          dropdownIsOpen ? 'rotate-180 text-core-purple' : 'text-core-grey-80'
        }`}
      />
    </div>
  )
}
